<template>
  <div>
    <v-select
      size="sm"
      :placeholder="isLoadingEmployeeListProp ? 'Loading...' : '-- Semua --'"
      :options="options"
      :reduce="(employee) => employee.value"
      label="text"
      v-model="modelValue"
      :disabled="isLoadingEmployeeListProp"
    />
    <small v-if="errors !== undefined" class="text-danger">{{ errors[0] }}</small>
  </div>
</template>

<script>
import vSelect from "vue-select";

export default {
  props: {
    isLoadingEmployeeList: [Boolean],
    filterBy: {
      type: String,
    },
    filterValue: {
      type: Number,
    },
    value: {
        type: String,
    },
    errors: {
        type: "",
    }
  },
  data() {
    return {
      isLoadingEmployeeListProp: true,
      options: [],
      filter: {
        branchId: null
      }
    };
  },
  components: {
    vSelect,
  },

  computed: {
    modelValue: {
      get: function () {
        if (this.value !== undefined) {
          return this.value;
        }
      },
      set: function (data) {
        window.console.log(data);
        this.$emit("value", null);
        if (data !== null) {
          this.$emit("value", data);
        }
      },
    },
  },

  watch: {
    isLoadingEmployeeList(value) {
      this.isLoadingEmployeeListProp = value
    },
    filterValue(value) {
      if (value !== null) {
        if (this.filterBy === 'branch') {
          this.$emit("value", null);
          this.filter.branchId = value
          this.isLoadingEmployeeListProp = true
          const self = this
          setTimeout(function() { self.getData() }, 500)
        }

      } else {
        this.filter.branchId = ""
        this.isLoadingEmployeeListProp = true
        const self = this
        setTimeout(function() { self.getData() }, 500)
      }
    },
  },
  methods: {
    getData() {
      const queryParams = this.filter

      this.$http
        .get("/employee/findAll/list")
        .then((response) => {
          let result = response.data.data;

          for (let i = 0; i < result.length; i++) {
            result[i].value = result[i].employeeId;
            result[i].text = result[i].fullName;
            delete result[i].key;
            delete result[i].label;
          }

          this.options = result;
          this.isLoadingEmployeeListProp = false
        });
    },
  },
  mounted() {
    this.getData();
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
